import { ContractingProcessAnswerProps } from "features/contracting/models/ContractingProcessAnswerProps";
import { setNoPlaceOfDeliveryQuestionsValidations } from "features/contracting/sections/contractingForms/processForm/processFormValidation";
import PageCard from "features/shared/components/card/PageCard";
import RadioBoxBoolSubForm from "features/shared/forms/components/radioBox/RadioBoxBoolSubForm";
import { RadioBoxDesignProps } from "features/shared/forms/components/radioBox/RadioBoxDesignProps";
import { useTranslationWithPrefix } from "features/shared/hooks/useTranslationWithPrefix";
import React, { useEffect } from "react";

interface Props extends ContractingProcessAnswerProps {
  objectPrefix: string;
}

const NoPlaceOfDeliveryQuestionsSubForm = ({
  formHandler,
  objectPrefix,
}: Props) => {
  //translations
  const tLabels = useTranslationWithPrefix("contracting\\contracting", "noPlaceOfDeliveryQuestionsSubForm");

  // form hook props
  const {
    clearFormValues,
    setValidationRule
  } = { ...formHandler };

  // side-effects
  useEffect(() => {
    // set default validations
    setNoPlaceOfDeliveryQuestionsValidations(setValidationRule, objectPrefix);

    return () => {
      // before unmount component remove values and validations
      setNoPlaceOfDeliveryQuestionsValidations(
        setValidationRule,
        objectPrefix,
        "remove"
      );
      clearFormValues([objectPrefix]);
    };
  }, []);

  // helpers
  const getInputName = (name: string) => {
    return `${objectPrefix}.${name}`;
  };

  // render
  return (
    <div className="row mx-n2">
      <div className="col-lg-6 px-2">
      <PageCard
        title={tLabels("existsConnectionContractCardTitle")}
        bodyClassName="pt-4 px-4"
        cardClassName="mb-4"
      >
        <div className="row mx-n2">
          <div className="col-lg px-2">
            <RadioBoxBoolSubForm 
              name={getInputName("existsConnectionContract")}
              label={tLabels("existsConnectionContract")}
              formHandler={formHandler}

            />
          </div>
        </div>
      </PageCard>
      </div>
      <div className="col-lg-6 px-2">
      <PageCard
        title={tLabels("ownerOfPropertyCardTitle")}
        bodyClassName="pt-4 px-4"
        cardClassName="mb-4"
      >
        <div className="row mx-n2">
          <div className="col-lg px-2">
            <RadioBoxBoolSubForm 
              name={getInputName("ownerOfProperty")}
              label={tLabels("ownerOfProperty")}
              formHandler={formHandler}
            />
          </div>
        </div>
      </PageCard>
      </div>
    </div>
  );
};

export default NoPlaceOfDeliveryQuestionsSubForm;
